import { OLD_TAX_YEAR } from "../../../shared/constants/taxYear";

export const OLD_TAX_CURRENT_YEAR = OLD_TAX_YEAR;
